import React from 'react';
import AdminForm from "../form/admin/AdminForm";
import {useHistory, useLocation} from "react-router";
import {queryParams} from "../utils/index";
import {ParsedUrlQuery} from "querystring";
import {REQUESTS_REDIRECT} from "../components/ReservedSwitcher";
import {VerticalLayout} from "../layout/VerticalLayout";
import {ConfigContext} from "../context/ConfigurationContext";
import {headerFromToken} from "../hook/index";
import ErrorMessage, {errorMessage} from "../components/ErrorMessage";
import Spinner from "../layout/Spinner";
import RequestList from "../form/admin/RequestList";
import {useKeycloak} from "@react-keycloak/web";
import {authFetch} from "../api/api";

interface AdminControllerInterface {}

export interface RequestsInterface {
    id: number;
    userEmail: string;
    type: 'consentGenRevoke' | 'consentFormRevoke';
    status: 'pending' | 'approved' | 'rejected';
    description: string;
    created: Date;
    lastUpdate: Date;
}

//[{"id":2,"userEmail":"utente-4@sergencovid.it","type":"consentGenRevoke","status":"pending","description":"mi va così ci ho ripensato","created":"2021-03-19T11:28:59","lastUpdate":"2021-03-19T11:28:59"}]

const AdminController: React.FC<AdminControllerInterface> = (props) => {
    const location = useLocation();
    const history = useHistory();
    const [status, setStatus] = React.useState(undefined as (string | undefined));
    const [loading, setLoading] = React.useState(false);
    const [fulfilled, setFulfilled] = React.useState(false);
    const [response, setResponse] = React.useState([] as Array<RequestsInterface>);
    const [error, setError] = React.useState(undefined as (undefined | number));
    const conf = React.useContext(ConfigContext);
    const {keycloak} = useKeycloak();

    let component = <></>;

    const loadResults = async (kc: Keycloak.KeycloakInstance, statusValue: string) => {
        const fetchHeader = (kc.authenticated ? {headers: headerFromToken(kc.token)} : {});

        const res = await fetch(`${conf['requestsPath']}?status=${statusValue}`, fetchHeader as any);

        return res;
    };


    React.useEffect(() => {
        const queryMap: ParsedUrlQuery = queryParams(location.search);

        if (queryMap['status'] === undefined) {
            history.push(REQUESTS_REDIRECT+'?status=pending');
        }

    }, []);


    React.useEffect(() => {
        const queryMap: ParsedUrlQuery = queryParams(location.search);
        const statusV = queryMap['status'];

        if (statusV !== undefined) {
            const statusValue = Array.isArray(statusV) ? statusV[0] : statusV;
            setStatus(statusValue);
        }

    }, [location]);



    React.useEffect(() => {

        if (status !== undefined) {
            setLoading(true);
            setFulfilled(false);
            setError(undefined);
            let errorValue = false;
            authFetch(keycloak, loadResults,status).then( r => {

                if (!r.ok) {
                    errorValue = true;
                    setError(r.status);
                }

                return r.json();
            }).
            then((res) => {
                if (!errorValue) {
                    setLoading(false);
                    setFulfilled(true);

                    const response: Array<RequestsInterface> = res as Array<RequestsInterface>;
                    setResponse(response);
                } else {
                    setLoading(false);
                }
            }).catch((e) => {
                setLoading(false);
                setError(900);
                console.log('Error ', e);
            })
        }
    }, [status]);


    if (error !== undefined) {
        component = <ErrorMessage kind={'error'} message={errorMessage[error]}/>
    }

    if (loading) {
        component = <Spinner/>;
    }

    if (fulfilled) {
        component = <RequestList status={status} requests={response}/>;
    }


    return (
        <VerticalLayout>
            <AdminForm/>
            {component}
        </VerticalLayout>
    )
};

export default AdminController;